import { FaPhone } from 'react-icons/fa';
import {
  SALES_PHONE_DISPLAY,
  SALES_PHONE_HREF,
  SALES_PHONE_LABEL,
} from '../../constants/contactInfo.js';
import './SalesPhone.css';

function SalesPhone({ className = '' }) {
  return (
    <a href={SALES_PHONE_HREF} className={`${className} salesPhone`}>
      <span className="salesPhone__label">{SALES_PHONE_LABEL}</span>
      <span className="salesPhone__number">
        <FaPhone aria-hidden="true" /> {SALES_PHONE_DISPLAY}
      </span>
    </a>
  );
}

export default SalesPhone;
